import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import "./ErrorReport.scss"

const ErrorReport = ({ title, subtitle, code, children }) => (
  <div className="ErrorReport">
    <div className="title">{title}</div>
    <div className="subtitle">{subtitle}</div>
    <Link className="btn btn-primary" to="/" hidden={!!children}>
      Take Me Home
    </Link>
    <div>{children}</div>
    {code && <div className="error-code">Error Code: {code}</div>}
  </div>
)

ErrorReport.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  code: PropTypes.number,
  children: PropTypes.node,
}

export default ErrorReport
